<div class="tt-shared-guideline-import-update-settings_update-mode">
  <div class="tt-shared-guideline-import-update-settings_title">{{ 'ImportGuidelineDialog.UpdateModeSelection' | transloco }}</div>
  <div class="tt-shared-guideline-import-update-settings_checkbox-container">
    <div class="tt-shared-guideline-import-update-settings_checkbox">
      <common-checkbox
        data-testid="import-guideline-dialog_manual-update-checkbox"
        [checked]="updateMode() === 'manual'"
        (checkedChange)="toggleManualUpdateMode()" />
      <div class="tt-shared-guideline-import-update-settings_checkbox-label" (click)="toggleManualUpdateMode()">
        {{ 'ImportGuidelineDialog.ManualUpdateLabel' | transloco }}
      </div>
    </div>
    <div class="tt-shared-guideline-import-update-settings_checkbox-description">
      {{ 'ImportGuidelineDialog.ManualUpdateDescription' | transloco }}
    </div>
  </div>
  <div class="tt-shared-guideline-import-update-settings_checkbox-container">
    <div class="tt-shared-guideline-import-update-settings_checkbox">
      <common-checkbox
        data-testid="import-guideline-dialog_automatic-update-checkbox"
        [checked]="updateMode() === 'automatic'"
        (checkedChange)="toggleAutomaticUpdateMode()" />
      <div class="tt-shared-guideline-import-update-settings_checkbox-label" (click)="toggleAutomaticUpdateMode()">
        {{ 'ImportGuidelineDialog.AutomaticUpdateLabel' | transloco }}
      </div>
    </div>
    <div class="tt-shared-guideline-import-update-settings_checkbox-description">
      {{ 'ImportGuidelineDialog.AutomaticUpdateDescription' | transloco }}
    </div>
    @if (updateMode() === 'automatic') {
      <tt-banner [message]="'ImportGuidelineDialog.AutomaticUpdateWarning' | transloco" [type]="'warning'" />
    }
  </div>
</div>

@if (updateMode() === 'automatic') {
  <div class="tt-shared-guideline-import-update-settings_email-notification">
    <div class="tt-shared-guideline-import-update-settings_title">{{ 'ImportGuidelineDialog.EmailNotification' | transloco }}</div>
    <div class="tt-shared-guideline-import-update-settings_checkbox-container">
      <div class="tt-shared-guideline-import-update-settings_checkbox">
        <common-checkbox
          data-testid="import-guideline-dialog_email-notification-checkbox"
          [checked]="forwardEmailNotifications()"
          (checkedChange)="toggleEmailNotification()" />
        <div class="tt-shared-guideline-import-update-settings_checkbox-label" (click)="toggleEmailNotification()">
          {{ 'ImportGuidelineDialog.EmailNotificationLabel' | transloco }}
        </div>
      </div>
      <div class="tt-shared-guideline-import-update-settings_checkbox-description">
        {{ 'ImportGuidelineDialog.EmailNotificationDescription' | transloco }}
      </div>
    </div>
  </div>
}
